export default class PagingModel {


    pageCount?: number;
    page?: number;
    pageSize?: number; // currently not used internally


    /**
     * Will create a new paging model for a new page.
     * will keep the current pageSize.
     * 
     * @param newPage
     */
    clone(newPage: number) {

        const cloned = new PagingModel();
        cloned.page = newPage;
        cloned.pageSize = this.pageSize;
        cloned.pageCount = this.pageCount;
        return cloned;
    }

    hasPaging(): boolean {

        // either pageCount is undefined, or 0 (default) otherwise it should be 1
        // for the 'first' page.

        return this.pageCount === undefined? false: (this.pageCount > 1);

    }


    private getValueFor(val: number| string | undefined): number | undefined {

        let returnValue = undefined;
        if (val !== undefined && val !== "") {

            if (typeof val === "number") {
                return val;
            }
            returnValue = parseInt(val);
            if (isNaN(returnValue)) {
                returnValue = undefined;
            }
        }


        return returnValue;
    }


    setPage(val: number | undefined) {

        this.page = this.getValueFor(val);
    }

    setPageCount(val: number | undefined) {

        this.pageCount = this.getValueFor(val);

    }

    setPageSize(val: number | undefined) {

        this.pageSize = this.getValueFor(val);
    }


    getPrevious(): number {

      
        if (this.page !== undefined) {

            if (this.page > 0) return this.page - 1;
        }
        return -1;
    }

    getNext() {

        if (this.page !== undefined && this.pageCount !== undefined) {

            if (this.page < (this.pageCount - 1)) return this.page + 1;
        }
        return -1;
    }


}
